import Vue from 'vue'
import api from './apis'
import axios from 'axios'

Vue.prototype.$api = api
Vue.prototype.$axios = axios


